exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-cart td[data-v-088c9ad8]{vertical-align:middle;padding-top:8px}.icon-remove[data-v-088c9ad8]{padding-right:5px}.license_description[data-v-088c9ad8]{margin-bottom:0;padding-left:23px}@media screen and (max-width:600px){.license_description[data-v-088c9ad8]{max-width:31%;margin-left:73%}}@media screen and (min-width:768px){.license_description[data-v-088c9ad8]{max-width:70%;margin-left:15%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-088c9ad8","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/store/components/TableItem.vue
// module id = jqYf
// module chunks = 102